"use client";

import React, { useEffect, useState } from "react";
import { formatDateMonthday, get } from "@/app/helpers";
import { IMG_URL } from "@/app/config";
import Link from "next/link";
import { useTheme } from "@/app/theme-provider";

export default function LatestNews({
  initialNews = [],
  initialLanguage = "ml",
}) {
  const { language } = useTheme();
  const [newsItems, setNewsItems] = useState(initialNews);

  useEffect(() => {
  

    let isMounted = true;

    get(`/website/homepage-news-and-events`)
      .then((res) => {
        if (isMounted) {
          setNewsItems(res?.data ?? []);
        }
      })
      .catch(() => {});

    return () => {
      isMounted = false;
    };
  }, [initialLanguage, language]);

  const highlightItem =
    newsItems.find((item) => item.highlight == true) ?? newsItems[0];
  const news = newsItems.filter((item) => item !== highlightItem);

  if (!highlightItem) {
    return null;
  }

  return (
    <section className="cmpad mt-40 ">
      <div className="d-flex justify-content-between align-items-center">
        <h2 className="head-h">{language == "en" ? "Latest News & Events" : "ഏറ്റവും പുതിയ വാർത്തകളും ഇവൻ്റുകളും"}</h2>
        <button className="view-btn"><Link href="/latest-news-updates">{language == "en" ? "View All" : "എല്ലാം കാണുക"}</Link><div className="View-icons"><img src="/icons/arrow.svg" alt='view' /></div></button>
      </div>
      <div className="row">
        <div className="col-lg-7 col-md-7 col-12 mt-3">
          {highlightItem?.photo && (
            <img src={`${IMG_URL}${highlightItem?.photo}`} alt="Latest News &amp; Events" className="ln-main-img" loading="lazy" decoding="async" />
          )}
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <p className="ln-main-head mt-3">{highlightItem?.name}</p>
              <span className="mute-text-date mt-2 mb-0">{language == "en" ? "Posted on" : "പോസ്റ്റ് ചെയ്തത്"} {formatDateMonthday(highlightItem?.date)}</span>
            </div>
            <button className="view-btn">
              <Link href={`/latest-news-updates/${highlightItem?.permalink}`}>{language == "en" ? "Read More" : "കൂടുതൽ വായിക്കുക"}</Link>
            </button>
          </div>
        </div>
        <div className="col-lg-5 col-md-5 col-12 mt-4 mt-md-3">
          {news.map((item, index) => (
            <Link key={item?.id ?? index} href={`/latest-news-updates/${item.permalink}`}>
              <div className="ln-sub-box">
                <div>
                  <img src={`${IMG_URL}${item.photo}`} alt="Latest News &amp; Events" loading="lazy" decoding="async" />
                </div>
                <div>
                  <span>{item.description}</span>
                  <p>{language == "en" ? "Posted on" : "പോസ്റ്റ് ചെയ്തത്"} {formatDateMonthday(item.date)}</p>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
